import React from "react";
import ChatLayout from "../../layouts/ChatLayout";

const ChatsPage = () => {
  return <ChatLayout />;
};

export default ChatsPage;
